export default __webpack_public_path__ + "static/midea-9d54d3b7cc06050bd6fe91da52ce656b.jpg";